/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DosespotMedication } from "./DosespotMedication";
import type { ParsedPrescriptionImageData } from "./ParsedPrescriptionImageData";
import type { PrescriptionImageParseResponseStatus } from "./PrescriptionImageParseResponseStatus";

/**
 * Status response for prescription parsing workflow.
 */
export interface PrescriptionImageParseResponse {
  status: PrescriptionImageParseResponseStatus;
  medications?: DosespotMedication[] | null;
  prescription_data?: ParsedPrescriptionImageData | null;
  error?: string | null;
}
